import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import useCustomToast from '@/hooks/useCustomToast'
import {
  askUserToRemoveItems,
  updateCartData,
} from '@/lib/reducers/cartReducer'
import { dispatch, useSelector } from '@/lib/store'
import { Fragment, useState } from 'react'
import CART_HELPER from '@/helper/cartHelper'
import { ChevronUp, PlusCircle, Trash2, XCircle } from 'lucide-react'
import { calculateAge, isEmpty } from '@/utils/commonFunc'
import { Button } from '../ui/button'
import { updatePackageData } from '@/lib/reducers/packageReducer'
import { DrawerFooter } from '../ui/drawer'
import ActionButton from '../common/ActionButton'
import { initSavingDto, updateOrderData } from '@/lib/reducers/orderReducer'
import { updateCommonReducerData } from '@/lib/reducers/commonReducer'
import { updateLoginData } from '@/lib/reducers/loginReducer'
import { DELETE_ACTION } from '@/utils/constants'

const TotalProductsInCart = ({ type = 'SCROLL' }) => {
  const { handleGetCartItems, handleAddOrRemoveProductInCart } = CART_HELPER()

  const showToast = useCustomToast()

  const cartState: any = useSelector((state) => state.cart) || {}
  const userState = useSelector((state) => state.user)
  const packageState = useSelector((state) => state.package)
  const orderState = useSelector((state) => state.order) || {}
  const commonState = useSelector((state) => state.common) || {}
  const loginState = useSelector((state) => state.login) || {}
  const cityState = useSelector((state) => state.city) || {}

  const CART_ITEMS = cartState?.cartDtoList || []

  const [openState, setOpenState] = useState(true)

  const collectiveCartItems = CART_ITEMS?.reduce((total: any, item: any) => {
    return total + item?.productDtoList?.length
  }, 0)

  const handleClearAllProductFromCart = (item: any) => {
    dispatch(
      askUserToRemoveItems({ ...cartState, itemToRemoveFromCart: { ...item } })
    )
  }

  const handleRemoveProduct = async (data: any) => {
    if (!loginState?.isUserLoggedIn) {
      dispatch(updateLoginData({ ...loginState, loginModalIsOpen: true }))
      return
    }
    dispatch(
      updateCommonReducerData({
        ...commonState,
        globalLoaderIsOpen: true,
      })
    )
    // setLoading(true)
    const apiResponse = await handleAddOrRemoveProductInCart(
      DELETE_ACTION,
      userState,
      data
    )
    if (apiResponse?.status === true) {
      if (!!apiResponse?.data[0]?.cityChanged) {
        showToast('warning', apiResponse?.data[0]?.message)
      }
      const res = await handleGetCartItems()
      dispatch(updateCartData({ ...cartState, ...res?.data }))
      dispatch(
        updateOrderData({
          ...orderState,
          cartDtoList: [...res?.data?.cartDtoList],
          savingDto: initSavingDto,
        })
      )
      // setLoading(false)
      dispatch(
        updateCommonReducerData({
          ...commonState,
          globalLoaderIsOpen: false,
        })
      )
    }
  }

  return (
    <Fragment>
      <div>
        <div className=" overflow-y-auto max-w-[650px] mx-auto">
          {CART_ITEMS?.length > 0 &&
            CART_ITEMS.map((item: any) => {
              const PATIENT_DETAIL = item?.patientDetailDto
              const INDIVIDUAL_CART_ITEM = item?.productDtoList
              return (
                <Card
                  className="bg-gray-100 rounded-xl border border-solid border-gray-200 shadow-none overflow-y-auto"
                  style={
                    type === 'SCROLL'
                      ? { maxHeight: 'calc(100vh - 230px)' }
                      : { maxHeight: 'unset' }
                  }
                  key={item.uuid}
                >
                  <CardHeader className="flex flex-row items-center justify-between px-5 pt-6 pb-4">
                    <div>
                      <CardTitle className="text-label-lg font-semibold ">{`${
                        !isEmpty(PATIENT_DETAIL?.firstName)
                          ? PATIENT_DETAIL?.firstName
                          : ''
                      } ${
                        !isEmpty(PATIENT_DETAIL?.lastName)
                          ? PATIENT_DETAIL?.lastName
                          : ''
                      }`}</CardTitle>
                      <CardDescription className="text-body-sm-medium text-gray-700 flex items-center gap-4">
                        <span>
                          <span className="capitalize">
                            {PATIENT_DETAIL?.age
                              ? PATIENT_DETAIL?.age
                              : calculateAge(PATIENT_DETAIL?.dob)}{' '}
                            Yrs /{' '}
                          </span>
                          <span className="capitalize">
                            {PATIENT_DETAIL?.gender?.toLocaleLowerCase()}
                          </span>
                        </span>
                        <Button
                          className="p-0 m-0 bg-transparent shadow-none text-body-sm text-primary-600 h-auto"
                          onClick={() => setOpenState((prev) => !prev)}
                        >
                          {collectiveCartItems} Tests added
                        </Button>
                        <button onClick={() => setOpenState((prev) => !prev)}>
                          <ChevronUp
                            size={16}
                            className={`text-gray-700 transition-all ease-in-out ${
                              openState ? 'rotate-0' : 'rotate-180'
                            }`}
                          />
                        </button>
                      </CardDescription>
                    </div>
                    <Button
                      className="bg-transparent p-0 m-0 shadow-none"
                      onClick={() => handleClearAllProductFromCart(item?.uuid)}
                    >
                      <Trash2 size={18} className="text-danger-500" />
                    </Button>
                  </CardHeader>
                  <CardContent className="p-2">
                    {openState && (
                      <div className="bg-white-100 rounded-md mb-2 shadow-elevation2 divide-y divide-gray-200 ">
                        {INDIVIDUAL_CART_ITEM?.length > 0 &&
                          INDIVIDUAL_CART_ITEM?.map((item: any) => {
                            const productItem = item
                            return (
                              <Fragment key={productItem?.id}>
                                <div className="p-3 flex justify-between items-center">
                                  <div>
                                    {!!productItem?.name && (
                                      <h4 className="text-body-sm-medium">
                                        {productItem?.name}
                                      </h4>
                                    )}
                                    {!!productItem?.numberOfTests && (
                                      <p className="text-label-sm text-gray-700">
                                        {productItem?.numberOfTests}
                                      </p>
                                    )}
                                  </div>
                                  <div className="flex items-center gap-4 divide-x-2 divide-gray-200">
                                    <div>
                                      <div className="flex items-center gap-2">
                                        {productItem?.marketPrice !==
                                          productItem?.price &&
                                          !!productItem?.toShowMarketPrice && (
                                            <p className="text-body-sm-medium line-through text-gray-500">
                                              ₹{productItem?.marketPrice}
                                            </p>
                                          )}
                                        <p className="text-body-sm-medium">
                                          ₹{productItem?.price}
                                        </p>
                                      </div>
                                      {!!productItem?.discountPercentage && (
                                        <p className="text-body-xs font-bold text-success-600 text-end">
                                          {productItem?.discountPercentage}% OFF
                                        </p>
                                      )}
                                    </div>
                                    <Button
                                      className="bg-transparent shadow-none p-2 m-0 rounded-none"
                                      onClick={() => handleRemoveProduct(item)}
                                    >
                                      <XCircle size={18} className="text-gray-400" />
                                    </Button>
                                  </div>
                                </div>
                              </Fragment>
                            )
                          })}
                      </div>
                    )}
                    <div>
                      <Button
                        className="bg-white-100 text-body-sm font-semibold text-gray-800 rounded-full h-auto p-2 w-full border border-solid border-gray-200 shadow-none flex gap-2 items-center leading-6"
                        onClick={() => {
                          dispatch(
                            updateCartData({ ...cartState, modalIsOpen: false })
                          )
                          dispatch(
                            updateCommonReducerData({
                              ...commonState,
                              cartModalIsOpen: false,
                            })
                          )
                          dispatch(
                            updatePackageData({
                              ...packageState,
                              modalIsOpen: true,
                            })
                          )
                        }}
                      >
                        <PlusCircle size={18} className="text-gray-700" /> Add tests
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )
            })}
        </div>
      </div>
      {CART_ITEMS?.length === 0 && (
        <Fragment>
          <div className="h-full grid place-content-center text-center max-h-[400px]">
            <p className="text-body-lg font-bold">Your cart is empty</p>
            <p className="text-body-sm font-semibold text-gray-700">
              Explore our lab tests and packages.
            </p>
          </div>
          <DrawerFooter className="px-6 py-5 sticky bottom-0 left-0 right-0 border-t border-solid border-gray-100">
            <ActionButton
              variant="primary"
              title="Add tests or packages"
              className="w-full"
              onClick={() => {
                dispatch(
                  updatePackageData({ ...packageState, modalIsOpen: true })
                )
              }}
            />
          </DrawerFooter>
        </Fragment>
      )}
    </Fragment>
  )
}

export default TotalProductsInCart
